export default {
  loading: false,
  loadingMentoryUser: false,
  mentoryUser : [],
};
